export { getDeviceInfo } from './amplitude';
